export default __webpack_public_path__ + "static/media/Version (5) - Deathly Hallows_20.f26e60e4.jpg";